// Analytics configuration - centralized settings for all tracking
export const ANALYTICS_CONFIG = {
  // Third-party integrations (enabled when env vars are set)
  GA4_ENABLED: !!import.meta.env.VITE_GA4_MEASUREMENT_ID,
  FB_PIXEL_ENABLED: !!import.meta.env.VITE_FB_PIXEL_ID,
  TIKTOK_PIXEL_ENABLED: !!import.meta.env.VITE_TIKTOK_PIXEL_ID,
  
  // Consent settings
  CONSENT_VERSION: 'v1.0',
  CONSENT_EXPIRY_DAYS: 365,
  CONSENT_STORAGE_KEY: 'elefa_cookie_consent',
  
  // Tracking settings
  ANONYMIZE_IP: true,
  TRACK_OUTBOUND_LINKS: true,
  TRACK_FILE_DOWNLOADS: true,
  TRACK_SCROLL_DEPTH: true,
  
  // Session settings
  VISITOR_ID_KEY: 'elefa_visitor_id',
  SESSION_ID_KEY: 'elefa_session_id',
  SESSION_TIMEOUT_MINUTES: 30,
  
  // Update intervals
  TIME_ON_SITE_UPDATE_SECONDS: 30,
  HEARTBEAT_INTERVAL_MS: 30000,
} as const;

export type ConsentCategory = 'essential' | 'analytics' | 'marketing';

export interface CookieConsent {
  essential: true; // Always true
  analytics: boolean;
  marketing: boolean;
  consentedAt: string;
  consentVersion: string;
}

export const DEFAULT_CONSENT: CookieConsent = {
  essential: true,
  analytics: false,
  marketing: false,
  consentedAt: '',
  consentVersion: ANALYTICS_CONFIG.CONSENT_VERSION,
};

// Cookie descriptions for consent UI
export const COOKIE_DESCRIPTIONS = {
  essential: {
    name: 'Essential',
    description: 'Required for the website to function. Cannot be disabled.',
    cookies: ['Session management', 'Security tokens', 'Consent preferences'],
  },
  analytics: {
    name: 'Analytics',
    description: 'Help us understand how visitors use our website.',
    cookies: ['Google Analytics', 'Page views', 'Time on site'],
  },
  marketing: {
    name: 'Marketing',
    description: 'Used to deliver relevant advertisements and track campaigns.',
    cookies: ['Facebook Pixel', 'TikTok Pixel', 'Conversion tracking'],
  },
} as const;
